export const environment = {
  admNome: 'Venda Online',
  apiUrl: 'https://api.g2saude.com.br/api/cliente',
  assets: 'propostadigital',
  base: 'aeduc',
  production: true,
  tipoPlanoId: 1, //1-plano de saude, 2-plano de odontologia, 3-plano pet
};
